"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitePendingPermissionsCard = exports.InvitePermissionsCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BasePermissionsCard_1 = require("Common/Permissions/BasePermissionsCard");
var GetFullName_1 = require("@CommonFrontendBackend/Utils/GetFullName");
var PendingUserPermissionsCard_1 = require("Common/Permissions/PendingUserPermissionsCard/PendingUserPermissionsCard");
var MentioningUserTooltipCopy = "Mentioning this user will let them edit and comment on this page";
var InvitePermissionsCard = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, email = _a.email;
    var name = (0, GetFullName_1.buildName)(firstName, lastName);
    return (react_1.default.createElement(kaleidoscope_2.Tooltip, { wrapTarget: true, content: MentioningUserTooltipCopy, size: kaleidoscope_2.TooltipSize.Large },
        react_1.default.createElement(BasePermissionsCard_1.BasePermissionsCard, { avatarSlot: react_1.default.createElement(InviteAvatar, { firstName: firstName, lastName: lastName }), descriptionSlot: email, nameSlot: react_1.default.createElement(InviteName, { name: name }) })));
};
exports.InvitePermissionsCard = InvitePermissionsCard;
var InvitePendingPermissionsCard = function (_a) {
    var email = _a.email;
    return (react_1.default.createElement(kaleidoscope_2.Tooltip, { wrapTarget: true, content: MentioningUserTooltipCopy, size: kaleidoscope_2.TooltipSize.Large },
        react_1.default.createElement(BasePermissionsCard_1.BasePermissionsCard, { avatarSlot: react_1.default.createElement(InviteAvatar, null), descriptionSlot: react_1.default.createElement(PendingUserPermissionsCard_1.PendingUserEmailSlot, null), nameSlot: react_1.default.createElement(InviteName, { name: email }) })));
};
exports.InvitePendingPermissionsCard = InvitePendingPermissionsCard;
var InviteAvatar = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    return (react_1.default.createElement("div", { className: "invite-permissions-card__avatar" },
        react_1.default.createElement(kaleidoscope_1.Avatar, { isInvite: true, firstName: firstName, lastName: lastName, size: kaleidoscope_1.AvatarSize.Small })));
};
var InviteName = function (_a) {
    var name = _a.name;
    return (react_1.default.createElement("div", { className: "invite-permissions-card__invite-name" },
        react_1.default.createElement("span", { className: "invite-text" }, "invite"),
        "\u00A0",
        react_1.default.createElement("span", null, name)));
};
